import { formatYmdInTimeZone, studioTodayYmd } from "@/lib/utils/date/studio-clock";

export const AVAILABILITY_DATE_NOT_IN_PAST_MESSAGE =
  "Date cannot be in the past.";

export const AVAILABILITY_DATE_RULE_DESCRIPTION =
  "The date must be today or in the future - past dates are not allowed.";

export function getTodayYmd(): string {
  return studioTodayYmd();
}

export function isAvailabilityDateYmdNotInPast(dateYmd: string): boolean {
  if (!dateYmd) return true;
  return dateYmd >= getTodayYmd();
}

export function isAvailabilityDateInPast(
  value: Date | string | null | undefined,
): boolean {
  if (!value) return false;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return false;
  return formatYmdInTimeZone(d) < getTodayYmd();
}

export function dateValueToYmd(value: {
  day: string;
  month: string;
  year: string;
}): string {
  if (!value.year || !value.month || !value.day) return "";
  return `${value.year}-${value.month.padStart(2, "0")}-${value.day.padStart(2, "0")}`;
}

export function getAvailabilityDatePickerError(
  error: unknown,
): { message?: string } | undefined {
  if (!error || typeof error !== "object") return undefined;
  const fieldError = error as { message?: string; root?: { message?: string } };
  if (fieldError.message) return { message: fieldError.message };
  if (fieldError.root?.message) return { message: fieldError.root.message };
  return undefined;
}
